// extracted by mini-css-extract-plugin
export default {"HeaderCentered":"HeaderCentered-module-a33ff8e6576adab1af0c"};